import React from 'react';
import { useTranslation } from 'react-i18next';

interface IntensityPanelProps {
  number?: number;
  maxNumber?: number;
  className?: string;
}

const IntensityPanel: React.FC<IntensityPanelProps> = ({ 
  number, 
  maxNumber = 9, 
  className = '' 
}) => {
  const { t } = useTranslation();
  const position = number ? ((number - 1) / (maxNumber - 1)) * 100 : 0;

  return (
    <div className={`mt-6 ${className}`}>
      <div className="text-sm font-semibold mb-2 text-white/90">
        {t('game.actingIntensity')}
      </div>
      <div className="px-[8px] bg-gradient-to-r from-green-400 to-red-500 h-4 rounded-full mx-4 shadow-inner border-[1px] border-white">
        <div className='w-full h-full relative'>
          {number && (
            <div 
              className="absolute top-1/2 transform -translate-x-1/2 -translate-y-1/2"
              style={{ left: `${position}%` }}
            >
              <div className="w-3 h-3 bg-white rounded-full shadow-lg border-2 border-gray-300"></div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default IntensityPanel;